// extracted by mini-css-extract-plugin
module.exports = {"m1tth7qf":"m1tth7qf","n1syjdo4":"n1syjdo4"};